"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _index = require("@/utils/index");
var _memberManagement = require("@/api/member/memberManagement");
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MemberSummary',
  props: {
    memberData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      tableData: [],
      loading: false
    };
  },
  methods: {
    // 获取汇总数据
    fetchSummaryData: function () {
      var _fetchSummaryData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!this.memberData || !this.memberData.id)) {
                _context.next = 1;
                break;
              }
              console.warn('会员数据不存在或缺少userId');
              this.tableData = [];
              return _context.abrupt("return");
            case 1:
              this.loading = true;
              _context.prev = 2;
              params = {
                userId: this.memberData.id
              };
              _context.next = 3;
              return (0, _memberManagement.xyUserExtendPage)(params);
            case 3:
              response = _context.sent;
              if (response && response.code === 200 && response.data) {
                this.tableData = this.convertToSummaryData(response.data);
              } else {
                this.tableData = [];
              }
              _context.next = 5;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](2);
              console.error('获取汇总数据失败:', _t);
              this.$message.error('获取汇总数据失败：' + (_t.message || '未知错误'));
              this.tableData = [];
            case 5:
              _context.prev = 5;
              this.loading = false;
              return _context.finish(5);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function fetchSummaryData() {
        return _fetchSummaryData.apply(this, arguments);
      }
      return fetchSummaryData;
    }(),
    // 将接口返回的数据转换为汇总表格显示数据
    convertToSummaryData: function convertToSummaryData(data) {
      return [{
        itemName: '会员ID',
        itemValue: data.userId || '-',
        remark: '会员唯一标识'
      }, {
        itemName: '第三方会员ID',
        itemValue: data.thirdUserId || '-',
        remark: 'POS系统会员ID'
      }, {
        itemName: '当前积分',
        itemValue: data.rankPoints || 0,
        remark: '当前可用积分'
      }, {
        itemName: '累计消费金额',
        itemValue: "\xA5".concat((data.consumeMoney || 0).toFixed(2)),
        remark: '历史累计消费总金额'
      }, {
        itemName: '累计消费次数',
        itemValue: "".concat(data.consumeTimes || 0, "\u6B21"),
        remark: '历史累计消费订单数'
      }, {
        itemName: '平均消费金额',
        itemValue: this.calculateAverageAmount(data.consumeMoney, data.consumeTimes),
        remark: '单次平均消费金额'
      }, {
        itemName: '会员等级',
        itemValue: data.cardName || '-',
        remark: '当前会员等级'
      }, {
        itemName: '最后消费时间',
        itemValue: this.formatTime(data.lastConsume),
        remark: '最近一次消费时间'
      }];
    },
    // 格式化时间（支持时间戳字符串如 "1773904987000"）
    formatTime: function formatTime(time) {
      if (!time || time === null || time === undefined) return '-';
      // 时间戳字符串转数字
      if (typeof time === 'string') {
        if (/^\d+$/.test(time)) {
          time = parseInt(time, 10);
        } else {
          return '-';
        }
      }
      if (typeof time === 'number' && time > 0) {
        var result = (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
        return result || '-';
      }
      return '-';
    },
    // 计算平均消费金额
    calculateAverageAmount: function calculateAverageAmount(totalAmount, totalTimes) {
      if (!totalAmount || !totalTimes || totalTimes === 0) {
        return '¥0.00';
      }
      var average = totalAmount / totalTimes;
      return "\xA5".concat(average.toFixed(2));
    }
  },
  watch: {
    memberData: {
      handler: function handler(newMemberData) {
        if (newMemberData && newMemberData.id) {
          this.fetchSummaryData();
        }
      },
      deep: true,
      immediate: true
    }
  }
};